import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { openWhatsApp } from "@/lib/whatsapp";

export default function FloatingWhatsApp() {
  return (
    <motion.button
      onClick={() => openWhatsApp()}
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -3 }}
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3.5 md:px-5 font-semibold text-white shadow-[0_16px_40px_rgba(37,211,102,0.45)]"
      data-testid="floating-whatsapp-btn"
      aria-label="Richiedi una visita su WhatsApp"
    >
      {/* pulse ring */}
      <span className="pointer-events-none absolute inset-0 -z-10 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <FaWhatsapp className="h-6 w-6 shrink-0" />
      <span className="hidden md:inline text-sm">Richiedi una visita</span>
      <span className="md:hidden text-sm">WhatsApp</span>
    </motion.button>
  );
}
